module.exports = __webpack_public_path__ + "img/group.8ae993b0.png";